import { fetchApi } from '@/common-utilities/fetch-utilities';
import { API_ENDPOINTS } from '@/common-constants/api-constants';
import type { User, UserUpdatePayload } from '@/common-types';
import type { UserResponse, UsersResponse } from '@/types/application/models/service/user-model-responses';

/**
 * Get current user profile
 */
export async function getCurrentUser(): Promise<User> {
  const response = await fetchApi<UserResponse>(API_ENDPOINTS.CURRENT_USER);
  return response.data.user;
}

/**
 * List all users (admin only)
 */
export async function listUsers(): Promise<User[]> {
  const response = await fetchApi<UsersResponse>(API_ENDPOINTS.USERS);
  return response.data.users;
}

/**
 * Get user by ID
 */
export async function getUser(userId: string): Promise<User> {
  const response = await fetchApi<UserResponse>(API_ENDPOINTS.USER_BY_ID(userId));
  return response.data.user;
}

/**
 * Update user role (admin only)
 */
export async function updateUser(userId: string, payload: UserUpdatePayload): Promise<User> {
  const response = await fetchApi<UserResponse>(API_ENDPOINTS.USER_BY_ID(userId), {
    method: 'PATCH',
    body: payload,
  });
  return response.data.user;
}

export default {
  getCurrentUser,
  listUsers,
  getUser,
  updateUser,
};


